module.exports = __webpack_public_path__ + "img/2-6.8ec8d1a0.png";